<template>
  <div>
    <input
      type="text"
      :value="landingPageUrl"
      class="w-full rounded-md border px-4 py-3"
      readonly
    />

    <div class="mt-3 flex flex-wrap items-center gap-3 lg:gap-4">
      <ShareCopyButton
        :source="landingPageUrl"
        :label="$t('copy_link')"
      />

      <div>
        <ShareOpenLink
          :href="openHref"
          :label="openLabel"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  landingPageUrl: string
  openHref: string
  openLabel: string
}>()
</script>
